import React, { memo } from 'react'
import styles from './styles.module.scss'
import { usePartnerFullName } from './usePartnerFullName.hook'
import PartnerFullNameInput from './PartnerFullNameInput'
import ProgressBar from '../ProgressBar'

interface PartnerFullNameTextProps {
  onSubmit: () => void
  isValid: boolean
  hasValue: boolean
}

// eslint-disable-next-line react/prop-types
const PartnerFullNameText: React.FC<PartnerFullNameTextProps> = memo(() => (
  <div className={styles.partnerFullNameTextContainer}>
    <span className={styles.partnerFullNameTitle}>Let's get to know each other.</span>
  </div>
))

PartnerFullNameText.displayName = 'PartnerFullNameText'

const PartnerFullName: React.FC = () => {
  const {
    fullName,
    partnerFullName,
    error,
    isValid,
    handleFullNameChange,
    handlePartnerFullNameChange,
    handleSubmit,
    onKeyDown,
  } = usePartnerFullName()

  const hasValue = fullName.trim().length > 0 && partnerFullName.trim().length > 0

  return (
    <>
      <ProgressBar />
      <div className={styles.partnerFullNamePage}>
        {/* Left section: Title & Next button */}
        <section className={styles.partnerFullNameLeftSection}>
          <PartnerFullNameText onSubmit={handleSubmit} isValid={isValid} hasValue={hasValue} />
        </section>

        {/* Right section: 2 input fields */}
        <section className={styles.partnerFullNameRightSection}>
          <div className={styles.partnerFullNameInputWrapper}>
            <PartnerFullNameInput
              fullName={fullName}
              partnerFullName={partnerFullName}
              error={error}
              onFullNameChange={handleFullNameChange}
              onPartnerFullNameChange={handlePartnerFullNameChange}
              onKeyDown={onKeyDown}
            />
          </div>
        </section>

        {/* Mobile button */}
        <button
          className={`${styles.partnerFullNameButtonMobile} ${hasValue ? styles.hasValue : ''}`}
          onClick={handleSubmit}
          disabled={!isValid}
        >
          NEXT
        </button>
      </div>

      <div className={styles.continueDesktopContainer}>
        <div className={styles.continueDesktopWrapper}>
          <button
            className={`${styles.continueButton} ${hasValue ? styles.hasValue : ''}`}
            onClick={handleSubmit}
            disabled={!isValid}
          >
            NEXT
          </button>
        </div>
      </div>
    </>
  )
}

PartnerFullName.displayName = 'PartnerFullName'

export default memo(PartnerFullName)
